<template>
  <v-col>
    <h3 style="text-align: center" class="mb-3 title">
      <slot name="title" />
    </h3>
    <div style="display: flex; justify-content: center" v-if="signed">
      <v-alert
        dense
        outlined
        type="error"
        color="red"
        elevation="5"
        text
        style="max-width: 500px"
      >
        {{
          higherOrder === true
            ? $tc("newController.higherOrder")
            : $tc("newController.notAction")
        }}</v-alert
      >
    </div>

    <v-expansion-panels>
      <v-expansion-panel class="expansion__panel">
        <v-expansion-panel-header class="my-4 container__panel">
          <div style="display: flex; flex-direction: row; max-width: 50px">
            <div class="btn__process">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="signed"
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    @click="pendingNovelty(items)"
                    class="btn__bell"
                    style="min-width: 45px"
                    v-show="localItems.noveltyEarring"
                  >
                    <v-icon small> fa-bell </v-icon>
                  </v-btn>
                </template>
                <span>Novedad pendiente</span>
              </v-tooltip>
            </div>
            <div class="btn__process">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="higherOrder"
                    rounded
                    class="btn-refresh ml-1"
                    v-on="on"
                    v-bind="attrs"
                    v-show="signed"
                    @click="withdrawSignature(items)"
                    style="min-width: 45px"
                  >
                    <v-icon small>fa-file-excel </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("gestionTiempos.removeFirm") }}</span>
              </v-tooltip>
            </div>
          </div>

          <div class="header-expansion-first px-4">
            <v-text-field
              :value="items.company + ' (' + items.file + ')'"
              style="max-width: 370px"
              label="Nombre"
              filled
              rounded
              dense
              disabled
              class="item-disabled"
              hide-details
            />
            <v-text-field
              style="max-width: 180px"
              label="Grupo"
              :value="
                parsedUpdatedItem[items.empId]
                  ? parsedUpdatedItem[items.empId].name
                  : items.group
              "
              filled
              rounded
              dense
              disabled
              hide-details
            />
            <v-text-field
              rounded
              dense
              filled
              :value="items.day"
              style="max-width: 130px"
              label="Día"
              disabled
              hide-details
            />
            <v-text-field
              rounded
              dense
              filled
              :value="items.date"
              style="max-width: 130px"
              label="Fecha"
              disabled
              hide-details
            />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="header-expansion">
            <v-text-field
              rounded
              dense
              filled
              :value="
                parsedUpdatedItem[items.empId]
                  ? parsedUpdatedItem[items.empId].name
                  : items.nameSchedule
              "
              style="max-width: 250px; width: auto"
              label="Horario"
              disabled
              hide-details
            />
            <v-text-field
              :value="formatDate(items.startDay)"
              style="max-width: 175px"
              label="Inicio del día"
              filled
              rounded
              dense
              disabled
              hide-details
            />
            <v-text-field
              :value="formatDate(items.endDay)"
              style="max-width: 175px"
              label="Fin del día"
              filled
              rounded
              dense
              disabled
              hide-details
            />
            <v-text-field
              :value="items.lab"
              style="max-width: 140px"
              label="Horas laborales"
              filled
              rounded
              dense
              disabled
              hide-details
            />
            <v-text-field
              :value="items.trab"
              style="max-width: 140px"
              label="Horas trabajadas"
              filled
              rounded
              dense
              disabled
              hide-details
            />
          </div>
          <div class="div-segments">
            <v-text-field
              rounded
              dense
              filled
              :value="getElement?.[0]?.nomSegm"
              style="max-width: 300px; width: auto"
              label="Segmento"
              disabled
              hide-details
            />
            <v-text-field
              rounded
              dense
              filled
              :value="duration.diaSemEx"
              style="max-width: 75px; width: auto"
              label="Día"
              disabled
              hide-details
            />
          </div>
          <div class="div-check">
            <v-checkbox
              :label="$tc('newController.absences')"
              v-model="items.aus"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.lates')"
              v-model="items.tar"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.falls')"
              v-model="items.hca"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.ret')"
              v-model="items.ret"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.inc')"
              v-model="items.inc"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.liD')"
              v-model="items.liD"
              disabled
              class="mr-3"
            />
            <v-checkbox
              label="Lic. Horas"
              v-model="items.liH"
              disabled
              class="mr-3"
            />
            <v-checkbox
              :label="$tc('newController.extras')"
              v-model="items.ext"
              disabled
            />
          </div>
          <v-list-group :value="false" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="title__header"
                  >{{ $tc("information.viewLiq") }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item style="padding-left: 16px">
              <v-list-item-content>
                <DataTable :headers="headers_liq" :items="getResults" />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="title__header"
                  >{{ $tc("information.viewRegistration") }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item style="padding-left: 16px">
              <v-list-item-content>
                <DataTable :headers="headers_reg" :items="getRegistrations" />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group :value="false" no-action sub-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="title__header"
                  >{{ $tc("information.scheduleElements") }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item style="padding-left: 16px">
              <v-list-item-content>
                <v-data-table
                  :headers="headers_ele"
                  :items="getElement"
                  :itemsPerPage="getElement.length"
                  class="elevation-3 dt px-4 mt-5"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-snackbar
      v-model="errorFirm"
      color="#FF8D58"
      class="snackbar"
      rounded="pill"
    >
      {{ textAlert }}
    </v-snackbar>
  </v-col>
</template>

<script>
import DataTable from "./DataTable.vue";
import registrations from "@/store/gestionTiempos/registrations";
import resultSettlementHours from "@/store/gestionTiempos/resultSettlementHours";
import signNovelty from "@/store/gestionTiempos/signNovelty";

export default {
  props: {
    items: Object,
    updatedItems: Array,
  },
  data() {
    return {
      parsedUpdatedItem: {},
      headers_reg: [
        {
          text: "Entrada",
          value: "entryWithModif",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Salida",
          value: "exitWithModif",
          class: "primary secondary--text",
          sortable: false,
          align: "center",
        },
        {
          text: "Concepto",
          value: "nameConcept",
          class: "primary secondary--text",
          align: "center",
        },
        {
          text: "Centro de costo",
          value: "nameCsCost",
          class: "primary secondary--text",
          align: "center",
        },
      ],
      headers_liq: [
        {
          text: "Concepto",
          value: "namConcept",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Centro de Costo",
          value: "nameCost",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad Liquidada",
          value: "settledAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad Autorizada",
          value: "authorizedAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Cantidad No autorizada",
          value: "unauthorizedAmount",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
      ],
      newItemRefresh: {},
      newArrayRefresh: [],
      headers_ele: [
        {
          text: "Elemento",
          value: "name",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Tol Entrada",
          value: "inputTol",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Tol Salida",
          value: "outputTol",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Concepto",
          value: "conceptName",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Laboral",
          value: "working",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Apl feriados",
          value: "holidays",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
        {
          text: "Apl No feriados",
          value: "notHolidays",
          class: "primary secondary--text",
          sortable: true,
          align: "center",
        },
      ],
      errorFirm: false,
      textAlert: "",
      localItems: { ...this.items },
    };
  },
  watch: {
    updatedItems(newQuestion, oldQuestion) {
      let object = {};
      this.updatedItems.forEach((element) => {
        object[element.empId] = {
          name: element.name,
        };
      });
      this.parsedUpdatedItem = object;
    },
  },
  mounted() {
    let date = this.localItems.date
      .slice(0, 10)
      .split(/\D/)
      .reverse()
      .join("-");
    resultSettlementHours.commit("setDate", date);
  },
  computed: {
    duration() {
      return this.$store.state.changeSchedule.stateDay;
    },
    higherOrder() {
      return this.$store.state.gestionTiempos.higherOrder;
    },
    signed: {
      get() {
        return this.$store.state.gestionTiempos.signed;
      },
      set(newValue) {
        return newValue;
      },
    },
    getResults() {
      return resultSettlementHours.state.settlementHours;
    },
    getRegistrations() {
      return registrations.state.registrations;
    },
    getElement() {
      return this.$store.state.changeSchedule.scheduleElement;
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const [date, time] = dateString.split(" ");
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year} ${time}`;
    },
    pendingNovelty(item) {
      let payload = {
        empId: item.empId,
        date: item.dateNotFormat,
      };
      this.$store.commit("gestionTiempos/setProcessNovelty", payload);
      this.$store.dispatch("gestionTiempos/processNovelty").then(() => {
        this.newFilterForRefresh(item);
      });
      this.$store.commit(
        "gestionTiempos/setDateForRefresh",
        item.dateNotFormat,
      );
    },
    newFilterForRefresh(item) {
      let filter = {
        Estado: {
          Anomalias: true,
          Normales: {
            Valor: true,
            Detalle: { DiasLiH: true, DiasLiD: true, SinNovedad: true },
          },
          Avisos: {
            Valor: true,
            Detalle: {
              DiasInc: true,
              DiasHca: true,
              DiasTar: true,
              DiasRet: true,
            },
          },
          Extras: true,
        },
        Empleados: [item.empId],
        Grupos: [],
        Horarios: [],
        Modelos: [],
        Atributos: [],
      };
      filter = JSON.stringify(filter);
      this.$store.dispatch("gestionTiempos/refreshNovelty", filter).then(() => {
        this.localItems =
          this.$store.state.gestionTiempos.refreshNovelty.item[0];

        this.newArrayRefresh = this.$store.state.gestionTiempos.novedades;

        let indice;
        this.newArrayRefresh.forEach((element, index) => {
          if (
            element.empId === item.empId &&
            element.dateNotFormat === item.dateNotFormat
          ) {
            indice = index;
            element.noveltyEarring = false;
            element.movimId = item.movimId;
          }
        });
        this.$store.state.gestionTiempos.novedades[indice] = this.localItems;
      });
    },
    withdrawSignature(item) {
      let payload = [];
      payload = [
        {
          flag: true,
          empId: item.empId,
          date: item.date,
        },
      ];
      signNovelty.commit("setNotFirm", payload);
      signNovelty
        .dispatch("notFirmNovelty")
        .then(() => {
          this.$store.commit("gestionTiempos/setSigned", false);
          this.pending();
          this.$store.commit(
            "gestionTiempos/setDateForRefresh",
            item.dateNotFormat,
          );
        })
        .catch((e) => {
          console.log("error", e);
          this.errorFirm = true;
          this.textAlert = "Error: no se pudo retirar la la firma";
        });
    },
    pending() {
      if (this.localItems.firm !== "Ninguno") {
        this.localItems.noveltyEarring = true;
      }
    },
  },
  components: { DataTable },
};
</script>

<style>
.btn__bell {
  border-radius: 20px !important;
  background-color: #f6f8fb !important;
  color: #ff8d58 !important;
  border: 2px solid #ced0d3;
  background-color: #f6f8fb;
}

.btn__bell:hover {
  background-color: #ff8d58 !important;
  color: #f6f8fb !important;
}

.btn-refresh {
  border-radius: 20px !important;
  background-color: #39537a !important;
  color: white !important;
  border: 2px solid #1d3861;
  background-color: #384b6d;
}

.btn-refresh:hover {
  background-color: #82a1d0 !important;
  color: #1d3861 !important;
}

.dt {
  overflow-y: scroll !important;
  height: 180px !important;
  padding: 0px !important;
  width: 100% !important;
}

.title {
  color: #39537a;
  font-weight: unset !important;
  margin-bottom: 20px !important;
}

.header-expansion-first {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.header-expansion {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media (min-width: 300px) and (max-width: 500px) {
  v-expansion-panel v-expansion-panel--active v-item--active {
    width: 370px !important;
  }

  .div-check {
    max-width: 360px !important;
    display: grid !important;
    grid-template-columns: auto auto auto;
    margin-top: 150px;
  }

  .header-expansion-first v-expansion-panel false {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .header-expansion {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

.v-label--is-disabled {
  color: rgb(83, 82, 82) !important;
}

.v-input--is-disabled {
  color: #909dfa !important;
}

.expansion__panel {
  max-width: 1050px !important;
}

input:disabled {
  color: rgb(83, 82, 82) !important;
}

.div-check {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.div-segments {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 20px;
}

.btn__process {
  max-width: 50px !important;
  height: 50px !important;
}

.container__panel {
  height: 60px !important;
}

.title__header {
  color: #39537a;
  font-weight: lighter;
  font-size: 17px;
}

@media (min-width: 300px) and (max-width: 850px) {
  .expansion__panel {
    max-width: 388px !important;
  }

  .header-expansion-first {
    display: grid !important;
    grid-template-columns: auto auto;
  }

  .container__panel {
    height: auto !important;
  }

  .btn__process {
    max-width: 50px !important;
    height: 50px !important;
  }
}
</style>
